import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../landing/header/Navbar";
import moment from "moment";
const BlogDetailBanner = ({ scrollToSecondSection, title, date }) => {
  const { t } = useTranslation();

  // const [showNav, setShowNav] = useState(true);

  // useEffect(() => {
  //   let timeoutId;

  //   const handleScroll = () => {
  //     setShowNav(true);
  //     clearTimeout(timeoutId);
  //     timeoutId = setTimeout(() => {
  //       setShowNav(false);
  //     }, 3000);
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //     clearTimeout(timeoutId);
  //   };
  // }, []);
  return (
    <>
      <Navbar />
      <section className="blog-banner blog-detail-banner">
        
        <img
          src="\assets\alldetailpages\detailimg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
                {/* <video
          className="main-banner-video11"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="\assets\videos\phonevideo.mp4" type="video/mp4" />
        </video> */}
         {/* <img
          src="\assets\blog\blog-bg-mbl.png"
          alt="img"
          className="img-fluid banner-bg d-none banner-bg-mbl"
        /> */}
        <div className="custom-container">
          <div className="latest-article">
            <div className="article-content" style={{maxWidth: "765px"}}>
              <h6 className="fontdetails" style={{fontSize: "50px"}}>{title}</h6>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetailBanner;
